export default "__VITE_ASSET__p66ksvaV__"